import React from 'react';
import { Checkboxes } from 'nhsuk-react-components';
import IdentityUserSelect from '../identityUserSelect/IdentityUserSelect.component';

const PatientEmailSelect = ({
    value,
    onChange,
    useNextOfKinEmail = false,
}) => {
    const handlePatientEmailChange = (data) => {
        if (onChange) {
            onChange({
                ...data,
                useNextOfKinEmail: false
            });
        }
    };

    const handleNOKEmailChange = (data) => {
        if (onChange) {
            onChange({
                ...data,
                useNextOfKinEmail: true
            });
        }
    };

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        if (onChange) {
            // When toggling, preserve the current email value but update the flag
            onChange({
                identityUserId: value?.identityUserId || null,
                email: value?.email || null,
                useNextOfKinEmail: checked
            });
        }
    };

    return (
        <div className="nhsuk-form-group">
            {!useNextOfKinEmail && (
                <IdentityUserSelect
                    value={value?.identityUserId}
                    onChange={handlePatientEmailChange}
                    primarySearchProp="userName"
                    secondarySearchProp="email"
                    disabled={false}
                    label="Add new email"
                />
            )}
            
            <div style={{ marginTop: '1rem' }}>
                <Checkboxes>
                    <Checkboxes.Box
                        checked={useNextOfKinEmail}
                        onChange={handleCheckboxChange}
                    >
                        Use Next of Kin Email address
                    </Checkboxes.Box>
                </Checkboxes>
            </div>

            {useNextOfKinEmail && (
                <>
                    <div style={{ 
                        marginTop: '1rem',
                        padding: '12px 16px',
                        backgroundColor: '#DFF2EA',
                        borderLeft: '4px solid #268756',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px'
                    }}>
                        <div style={{
                            width: '24px',
                            height: '24px',
                            borderRadius: '4px',
                            backgroundColor: '#268756',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            flexShrink: 0
                        }}>
                            ✓
                        </div>
                        <div style={{
                            color: '#0B4A2D',
                            fontSize: '14px',
                            fontStyle: 'italic'
                        }}>
                            Patient consent confirmed: Next of kin is authorised to access this profile
                        </div>
                    </div>
                    <div style={{ marginTop: '1rem' }}>
                        <IdentityUserSelect
                            value={value?.identityUserId}
                            onChange={handleNOKEmailChange}
                            primarySearchProp="userName"
                            secondarySearchProp="email"
                            disabled={false}
                            label="Next of Kin Email Address"
                            createNewLabel="Create a new email"
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default PatientEmailSelect;

